<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="headerpt0101" class="chapter" epub:type="part" id="pt01" role="doc-part">
<header id="headerpt0101">
<h1 class="pn"><span aria-label="36" class="page" id="p36" role="doc-pagebreak"></span><span aria-label="37" class="page" id="p37" role="doc-pagebreak"></span><a class="xref" href="#/chicrosson0007#toc">I</a></h1>
<h1 class="pt">The Depths</h1>
</header>
<figure class="figure" id="fig0101">
<p class="fig"><span aria-label="38" class="page" id="p38" role="doc-pagebreak"></span><img alt="" height="401" src="images/chi-crosson-fig01001.jpeg" width="600"/></p>
<p class="figh"><span class="fighn">Figure 1.1.</span> Funeral procession for one of the victims of the police shootings, along the edge of the abandoned cane fields in Rio Moro. Photograph by the author, 2011.</p>
</figure>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-crosson-0010.vue?af35d94e